import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Institution16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.33541 0.829241C8.12427 0.723668 7.87574 0.723668 7.6646 0.829241L0.664595 4.32924C0.252461 4.53531 0.123538 5.08144 0.400006 5.45006L1.75 7.25005V13.25H0V14.75H16V13.25H14.25V7.25007L15.6 5.45006C15.8765 5.08144 15.7475 4.53531 15.3354 4.32924L8.33541 0.829241ZM12.75 7.75006H10.75V13.25H12.75V7.75006ZM9.25 7.75006H6.75V13.25H9.25V7.75006ZM5.25 7.75006H3.25V13.25H5.25V7.75006ZM2.87501 6.25006L2.1392 5.26899L8.00001 2.33859L13.8608 5.26899L13.125 6.25006H2.87501Z'
      fill='currentColor'
    />
  </Svg>
);

Institution16.displayName = 'Institution16';
export default Institution16;
